import Proptypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';

import CPPageHeader from '@components/ClientPortal/CPPageHeader';
import { isStickyHeader$ } from '@components/Product/VariantDetail/ProductDetailHeader/handleStickyHeaderService';
import SitecoreContextFactoryService from '@services/sitecoreContextFactoryService';
import { useGetMemberUsualText } from '@utils/customsHook/useGetMemberUsualText';

import { QuestionTooltipIcon } from '../../ProductCardPrice/QuestionTooltipIcon';

const BundleBOHeader = (props) => {
  const { bundleName, totalSellingPriceText, totalListPriceText } = props;
  const [isBundleBOHeaderSticky, setIsBundleBOHeaderSticky] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const isClientTelingUser = SitecoreContextFactoryService.getValueContextItem('isClientTelingUser');

  const {
    memberText,
    usualText
  } = useGetMemberUsualText();

  useEffect(() => {
    const onScroll = (e) => {
      setScrollTop(e.target.documentElement.scrollTop);
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollTop]);

  useEffect(() => {
    if (scrollTop > 0) {
      setIsBundleBOHeaderSticky(true);

      isStickyHeader$.next(true);
    } else {
      setIsBundleBOHeaderSticky(false);

      isStickyHeader$.next(false);
    }
  }, [scrollTop]);

  return (
    <Fragment>
      {isClientTelingUser ? (
        <CPPageHeader title={SitecoreContextFactoryService.getValueContextRouteItem('displayName')} />
      ) : (
        <div className={`buying-option-header${isBundleBOHeaderSticky ? ' buying-option-header-sticky' : ''}`}>
          <div className='container buying-option-header__wrap'>
            <div className='buying-option-header__text'>
              <span className='buying-option-header__text__name' title={`${bundleName}`}>{bundleName}</span>
              <div className='buying-option-header__text__price'>
                {totalSellingPriceText === totalListPriceText ? (
                  <span className='buying-option-header__text__price__current'>{totalSellingPriceText}</span>
                )
                  : (
                    <Fragment>
                      <span className='buying-option-header__text__price__current'>{memberText}{totalSellingPriceText}
                        <QuestionTooltipIcon />
                      </span>
                      {usualText ? (
                        <span className='buying-option-header__text__price__old'>{usualText}{totalListPriceText}</span>
                      ) : (
                        <del className='buying-option-header__text__price__old'>{totalListPriceText}</del>
                      )}
                    </Fragment>
                  )}
              </div>
            </div>
            {props.children}
          </div>
        </div>
      )}
    </Fragment>
  );
};

BundleBOHeader.propTypes = {
  bundleName: Proptypes.any,
  children: Proptypes.any,
  totalSellingPriceText: Proptypes.any,
  totalListPriceText: Proptypes.any,
  CurrencyCode: Proptypes.any,
};

export default BundleBOHeader;
